// extracted by mini-css-extract-plugin
export default {"root":"PayPalButton_root__+pBV2","loading":"PayPalButton_loading__Mdu0a","buttonContainer":"PayPalButton_buttonContainer__KseJG","error":"PayPalButton_error__1UWyd"};